import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/apiClient';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';

export interface InvoiceParam {
  paramId: string;
  paramName: string;
  paramValue: string;
  isVisible: boolean;
}

export interface UseInvoiceParams {
  invoiceId: string;
  enabled?: boolean;
}

export function useInvoice({ invoiceId, enabled = true }: UseInvoiceParams) {
  return useQuery({
    queryKey: ['invoice', invoiceId],
    queryFn: async (): Promise<InvoiceParam[]> => {
      const response = await apiClient.get(
        `/operations/bank/deposit/invoices/${invoiceId}`
      );

      return response.data as InvoiceParam[];
    },
    enabled: enabled && !!invoiceId,
    staleTime: CACHE_TIME_5_MINUTES,
    retry: 2,
  });
}
